import { Blockquote } from "./Blockquote";

export { Blockquote };
